import { Link, useLocation } from "react-router-dom";
import { HOME_PATH, HOME_SEARCH_PATH } from "../utility/path";
import { useSelector } from "react-redux";
import "../NoDataFound.css";

const ServiceDowntime = ({}) => {
  
  const rawData = localStorage.getItem('init');
  const parsedData = JSON.parse(rawData);
  const sd = parsedData?.sd;

  // Determine the appropriate path dynamically
  return (
    <div>
      {
        <div className="ndf-wrapper">
          <div className="ndf-card">
            <div className="ndf-icon">Gaufi</div>
            <small>Find skilled professionals near you..</small>
            <p>&nbsp;</p>
            {/* Icon */}
            <div className="ndf-icon">🛠️</div>

            {/* Text */}
            <p className="ndf-title">{sd?.message1 ? sd?.message1 : "Temporary Service Unvailable Due to Maintenace"}</p>
            <p className="ndf-subtitle">
              {sd?.message2 ? sd?.message2 : "Please try again in sometime. Thankyou for your patience."}
            </p>

            {/* Suggestions */}
            <div className="ndf-suggestions">
              {/* <div className="ndf-suggestion">
                <i className="fa fa-map-marker ndf-suggestion__icon" />
                <span>Try a nearby area or pin code</span>
              </div> */}
              {/* <div className="ndf-suggestion">
                <i className="fa fa-th-large ndf-suggestion__icon" />
                <span>Browse a similar category</span>
              </div> */}
            </div>

            {/* CTA */}
            {/* <Link to={backToPath}>
              <button className="ndf-btn">
                Go back to categories
              </button>
            </Link> */}
          </div>
        </div>
      }
    </div>
  );
};

export default ServiceDowntime;
